import { clone } from "../../core/index.js";
export function structureModelAddDefaultValues(structure, configuration) {
    const result = clone(structure);
    const classes = result.getClasses();
    for (const classData of classes) {
        classData.instancesHaveIdentity ??= configuration.instancesHaveIdentity;
        classData.instancesSpecifyTypes ??= configuration.instancesSpecifyTypes;
        classData.isClosed ??= configuration.dataPsmIsClosed == "CLOSED";
    }
    return result;
}
//# sourceMappingURL=add-default-values.js.map